<script setup lang="ts">
  import { useAppModal } from '@/components/modal'
  import { useSaleCreate } from '@/models/sale'
  import SaleForm from '../sale-form.vue'

  const emit = defineEmits<{
    (e: 'created'): void,
  }>()

  const { form, errors, submitting, submitForm } = useSaleCreate()
  const { modal, open, close } = useAppModal(() => {
    form.sale_items = ['']
    errors.value = {}
  })
  defineExpose({ open })

  const submit = async () => {
    const response = await submitForm()

    if (response != null) {
      emit('created')
      close()
    }
  }

</script>

<template>
  <app-modal
    ref="modal"
    title="Tambah Penjualan">
    <sale-form
      v-model="form"
      :errors="errors"
      :submitting="submitting"
      @close="close"
      @submit="submit" />
  </app-modal>
</template>
